import React from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInputProps,
  createStyles,
  makeStyles
} from '@material-ui/core';
import StyledOutlinedInput from '../FormInput/StyledOutlinedInput';
import {useTranslation} from 'react-i18next';
import {INPUT_BORDER_COLOR, INPUT_LABEL_COLOR} from 'src/style/variable';

interface IInputField extends Omit<OutlinedInputProps, 'error'> {
  label?: string;
  error?: Record<string, any>;
}

const useStyles = makeStyles(() => {
  return createStyles({
    outlinedInput: {
      '& input': {
        paddingBlock: '0.8rem'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: INPUT_BORDER_COLOR
      }
    },
    formControl: {
      paddingBottom: 0,
      marginBottom: 0,
      '& .MuiFormLabel-asterisk': {
        color: 'inherit'
      }
    }
  });
});

const InputField = (props: IInputField): JSX.Element => {
  const {label, error, ...rest} = props;
  const {t} = useTranslation();
  const classes = useStyles();
  return (
    <FormControl
      error={!!error}
      fullWidth={true}
      variant="standard"
      className={`pc-form-field-${rest.type} ${classes.formControl}`}
      required={rest?.required}>
      {label && (
        <InputLabel
          style={{
            position: 'static',
            transform: 'none',
            marginBottom: '0.5rem',
            fontSize: '1.1rem',
            color: INPUT_LABEL_COLOR
            // .MuiFormLabel-root.Mui-error to override the color
          }}
          shrink>
          {label}
        </InputLabel>
      )}
      <StyledOutlinedInput
        className={classes.outlinedInput}
        autoComplete="on"
        {...rest}
      />
      {error && <FormHelperText>{t(error.message)}</FormHelperText>}
    </FormControl>
  );
};

export default InputField;
